import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";

export default () =>
  axiosApi.get(`${BackendServices.USER_SERVICE.USER}/checkSahringOptions`);